import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "human-rehabilitation",
  "use": "human-rehabilitation-usage",
  "viewBox": "0 0 64 22",
  "content": "<symbol viewBox=\"0 0 64 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"human-rehabilitation\"><path d=\"M0 0.999654H4.89581C10.1773 0.999654 14.1779 5.76911 13.2589 10.97V10.97C12.3399 16.1709 16.3405 20.9404 21.622 20.9404L31.2978 20.9404L41.2327 20.9404H63.5537\" stroke-width=\"1.5\" /><circle cx=\"4\" cy=\"4\" r=\"3.25\" transform=\"matrix(1 0 0 -1 38 21)\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol